module.exports = __webpack_public_path__ + "img/progress_039.f073ad91.png";